import { CompanyDetailsTabBaseDataProvider } from './CompanyDetailsTabBaseDataProvider';
import { CompanyData } from '../../../types/company-data';

export class CompanyDetailsTabGzDataProvider extends CompanyDetailsTabBaseDataProvider {
  public async getMyCompanyData(): Promise<CompanyData> {
    const record = await this.dependencies.api.clients.MyCompany.GetRecord().toPromise();

    if (!record || !record.data) {
      throw new Error('No my company data');
    }

    return record.data;
  }

  public async getManagedCompanyById(companyId: string): Promise<CompanyData> {
    const record = await this.dependencies.api.clients.Company.GetManagedCompanyById(companyId).toPromise();

    if (!record) {
      throw new Error('No edited company data');
    }

    return record;
  }
}
